/* The minimum length for a company name */
export const MINIMUM_COMPANY_NAME_LENGTH = 3;

/* The maximum number of companies to display in a table */
export const MAXIMUM_NUMBER_OF_COMPANIES_IN_TABLE = 3;
